import { apiHelper } from '@/utils'
import { API, SHARED } from '@/constants'

export const domainGroupService = {
    getAllDomainGroups,
    getDomainGroup,
    createDomainGroup,
    updateDomainGroup,
    updateDomainGroupStatus,
    updateDomainGroupDomains,
    getDomainGroupCandidates,
  };

const MODULE = {
    DOMAIN_GROUP: 'domain-groups',
}

const API_URL = API.BASE_URL + '/v1'


export function getAllDomainGroups(filter) {

    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
      }
    }

    if (filter.isActive != null && filter.isActive !== SHARED.DEFAULT_ALL_VALUE) {
      requestOptions.params.is_active = filter.isActive
    }

    let array = filter.searchArray || []
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })

    return apiHelper(API_URL).get(`/${MODULE.DOMAIN_GROUP}`, requestOptions)
}

export function getDomainGroup(uuid) {
  return apiHelper(API_URL).get(`/${MODULE.DOMAIN_GROUP}/${uuid}`)
}

export function createDomainGroup(data) {
  const requestOptions = {
    name: data.name,
    slug: data.slug || null,
    country_code: data.countryCode,
  }

  return apiHelper(API_URL).post(`/${MODULE.DOMAIN_GROUP}`, requestOptions)
}

export function updateDomainGroup(uuid, data) {
  const requestOptions = {
    name: data.name,
    slug: data.slug || null,
  }

  return apiHelper(API_URL).put(`/${MODULE.DOMAIN_GROUP}/${uuid}`, requestOptions)
}

export function updateDomainGroupStatus(data) {
  const requestOptions = {
    is_active: data.isActive ? 1 : 0
  }

  return apiHelper(API_URL).patch(`/${MODULE.DOMAIN_GROUP}/${data.uuid}/status`, requestOptions)
}

// Sets the full membership of the group; domains not listed are detached.
export function updateDomainGroupDomains(uuid, domains) {
  const requestOptions = {
    domains: domains.map((d) => {
      return {
        uuid: d.uuid,
        priority: d.priority
      }
    })
  }

  return apiHelper(API_URL).put(`/${MODULE.DOMAIN_GROUP}/${uuid}/domains`, requestOptions)
}


export function getDomainGroupCandidates(uuid) {
  return apiHelper(API_URL).get(`/${MODULE.DOMAIN_GROUP}/${uuid}/candidates`)
}
